import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const QuotationDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'quotation',
        routeParamKey: 'quotationId',
        pageTitle: 'Quotation Details',
        backRoute: '/quotations',
        backLabel: 'Back to Quotations',
        tabIdPrefix: 'quotation',
        tabsAriaLabel: 'quotation detail tabs',
        missingIdMessage: 'No quotation ID provided in the URL.',
        noDataMessage: 'No quotation data available. The quotation might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default QuotationDetailPage;
